export default {
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    '&: h1': {
      fontSize: 28,
      margin: '0 0 40px 0',
    },
  },
  inner: {
    position: 'absolute',
    width: '100%',
    maxWidth: 360,
    left: 0,
    right: 0,
    top: '50%',
    margin: 'auto',
    transform: 'translateY(-50%)',
  },
  logo: {
    marginBottom: '75px',
  },
}



// WEBPACK FOOTER //
// ./src/Components/Auth/PublicInformationView/styles.js